<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formInline.name" clearable placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="formInline.mobile" clearable placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="name" label="姓名" align="center" />
      <el-table-column prop="idNo" label="身份证号" align="center" />
      <el-table-column prop="mobile" label="手机号" align="center" />
      <el-table-column prop="sex" label="性别" align="center">
        <template #default="scope">
          <span v-if="scope.row.sex == '1'">男</span>
          <span v-if="scope.row.sex == '2'">女</span>
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" align="center" />
      <el-table-column prop="createTime" label="创建时间" align="center" />
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { Upload, ArrowRightBold, ArrowDownBold } from "@element-plus/icons-vue";
import service from "@/http/request.js";
const tableData = ref([]);

const formInline = reactive({
  name: null,
  mobile: null,
});
const searchFormRef = ref();
const onSubmit = () => {
  _userList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _userList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _userList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _userList();
};
const _userList = () => {
  service.post('/health/web/healthUser/page', {
    pageSize: pageSize.value || null,
    pageNo: currentPage.value || null,
    ...formInline
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        tableData.value = data.data.data.records
        total.value = data.data.data.total
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};

onMounted(() => {
  _userList();
});

</script>
<style scoped lang="scss">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}
.blue{
  color: #0051b7;
}
</style>
